<template>
  <div>
    <div class="header py-7 py-lg-4 pt-lg-9"></div>
    <b-container class="mt--8 pb-5">
      <b-row v-if="error" class="justify-content-center">
        <b-col md="8">
          <b-alert show variant="danger">{{ error }}</b-alert>
        </b-col>
      </b-row>
      <b-row v-else class="justify-content-center">
        <b-col md="8" class="text-center text-muted">
          <p>Redirecting to your quote...</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      error: null,
    };
  },
  async mounted() {
    const quoteId = this.$route.params.quoteId;
    if (!quoteId) {
      this.error = "Invalid Cloudfloat return link.";
      return;
    }

    const base = (process.env.VUE_APP_APIENDPOINT || "").replace(/\/$/, "");
    if (!base) {
      this.error = "Unable to connect to the server.";
      return;
    }

    try {
      const flow = this.$route.query.flow;
      const params = new URLSearchParams();
      if (flow) {
        params.set("flow", String(flow));
      }
      const query = params.toString();
      const resp = await axios.get(
        `${base}/live/motor/policyByCloudfloatQuoteId/${encodeURIComponent(quoteId)}${
          query ? `?${query}` : ""
        }`
      );
      const guid = resp.data?.Customer_policy_guid;
      if (!guid) {
        this.error = "Quote not found.";
        return;
      }

      const productCode = resp.data?.Product_code;
      const continuePath =
        productCode === "YIHQ-PSLIVE"
          ? `/ps-live/continueQuote/${guid}`
          : `/motor-live/continueQuote/${guid}`;

      this.$router.replace({
        path: continuePath,
        query: { ...this.$route.query },
      });
    } catch (err) {
      console.error("Cloudfloat return redirect failed", err);
      this.error = "Unable to find your quote. Please contact support.";
    }
  },
};
</script>
